// What is being heard right now, shown as the last item of the conversation: the reader's
// own message shape, visibly unsent. It disappears when the turn is sent and the real
// message arrives through the normal flow.

export function ListeningBubble({ text }: { text: string }): JSX.Element {
  return (
    <li className="message message--mine message--listening" aria-label="Listening">
      <div className="message__content">
        <p className="message__body">{text}</p>
      </div>
    </li>
  );
}
